import { useMongoQuery } from "contexts/useMongoQuery";

const useDocks = (book_id: string) => {
  const { data, loading, error } = useMongoQuery("docks", { book_id: parseFloat(book_id) })
  const dock = data ?? {}
  return {
    loading,
    dock,
  };
};
export default useDocks;